export default __webpack_public_path__ + "static/B0007-cbe86ddc9e37944cc0c7da42b53aadf9.png";